module.exports = __webpack_public_path__ + "img/jy2.a68161c2.png";